import { render, staticRenderFns } from "./KycCheck.vue?vue&type=template&id=6f581140&"
import script from "./KycCheck.vue?vue&type=script&lang=js&"
export * from "./KycCheck.vue?vue&type=script&lang=js&"
import style0 from "./KycCheck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports